import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, filter, map, take, timeout } from 'rxjs/operators';
import { AuthCheckService } from '../services/auth-check.service';
import { DadosLoginService } from '../services/dados-login.service';

export const portalGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const dadosLoginService = inject(DadosLoginService);
    const authCheckService = inject(AuthCheckService);

    if (!authCheckService.isLogged) {
        return true;
    }

    const { portal } = route.data;

    if (!portal) {
        console.warn('Portal não especificado no data da rota');
        return true;
    }

    return dadosLoginService.dadosLogin$.pipe(
        filter(dadosLogin => dadosLogin !== null),
        take(1),
        timeout(10000),
        map(dadosLogin => {
            if (!dadosLogin) {
                router.navigate(['/auth/login']);
                return false;
            }

            const hasPortalAccess = dadosLogin.portais.includes(portal);

            if (!hasPortalAccess) {
                const isInitialNav =
                    !router.getCurrentNavigation()?.previousNavigation;
                router.navigate(['/pages/access-denied'], {
                    queryParams: {
                        path: state.url,
                        portal: portal,
                        initial: isInitialNav ? '1' : undefined,
                    },
                    replaceUrl: !!isInitialNav,
                });
                return false;
            }

            return true;
        }),
        catchError(error => {
            console.error('Erro no carregamento de dados de login:', error);
            router.navigate(['/auth/login']);
            return of(false);
        })
    );
};
